import React from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", label: "En" },
  { code: "uz", label: "Uz" },
  { code: "ru", label: "Ru" },
];

export default function LangSwitcher() {
  const { i18n } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(e.target.value);
    localStorage.setItem("locale", e.target.value);
  };

  return (
    <select
      onChange={handleChange}
      value={i18n.language}
      className="lang-switcher simple-btn only-desktop cacl-btn primary-5-gradient-bg natural-8 text-bold size-8"
    >
      {languages.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {lang.label}
        </option>
      ))}
    </select>
  );
}
